import { recursiveCopy,parse_filters } from '@/functions/general.js';

const defaultValues = {
  string: ()=>'',
  array: () => [],
  object: () => {return {}},
  boolean: ()=>false,
  file: () => {return {}},
  phone: ()=>null,
  date: ()=>null,
  int:()=>null,
  time: ()=>null,
}
function is_empty(val, type) {
  if ([undefined,null].includes(val)) return true
  if (type === 'string' && val === '') return true;
  if (type === 'array' && val.length === 0) return true;
  if (type === 'file' && Object.keys(val).length === 0) return true;
  if (['int','phone'].includes(type) && isNaN(val)) return true;
  if (type === 'boolean' && ![false,true].includes(val)) return true;
  return false
}
const indx_def = {
  'function':(i)=>i(),
  'object':(i)=>i()
};
const defaultItem = function() {
  const defaultItem = {}
  if (this.scheme) {
    Object.keys(this.scheme).forEach(key => {
      if (this.scheme[key].type === undefined) {
        console.error(key, ' no tiene tipo de variable para asignar un valor');
        return
      }
      defaultItem[key] = this.scheme[key].default !== undefined
        //? this.getDefaultValue(this.scheme[key].default):
        ? ((d) => indx_def[typeof d] && d !== null ?  indx_def[typeof d](d): (d))(this.scheme[key].default)
        : this.defaultValues[this.scheme[key].type]();
    })
  } // if
  return defaultItem;
}
function toSaveF(selectedItem, scheme) {
  let toSave = {...selectedItem}
    Object.keys(scheme).forEach(f => {
      // no enviar si es archivo y esta la url pq, si esta asi no hay q guardarlo0
      if (scheme[f].type === 'file' && (typeof selectedItem[f] !== 'object' || selectedItem[f] === null)) {
        delete toSave[f];
      }
      if (scheme[f].notNull && selectedItem[f] === null) {
        delete toSave[f];
      }
    });
    return toSave
}
const beforeSaveIncomplete = function() {
  const keys = Object.keys(this.schemeNotNull);
  if (keys.length === 0) return true;
  const empty_atrs = keys.filter(k => is_empty(this.selectedItem[k], this.scheme[k].type));

  if (empty_atrs.length) {
    //this.$store.dispatch('set',{key:'incompleteItems', val:empty_atrs.map(k => (this.flds.find(f => f.key===k) || {}).name || k)});
    this.$store.dispatch('set',{key:'incompleteItems', val:empty_atrs.map(k => this.schemeNotNull[k].label)});
    return false
  }
  return true
}
const save = async function() {
  if (!this.scheme) console.warn('no hay scheme definido !!');
  
  let toSave = this.scheme ? toSaveF(recursiveCopy(this.selectedItem), this.scheme): recursiveCopy(this.selectedItem);

  this.setProgress({message: 'Guardando...', show:true});
  const method = this.selectedItem.id ? this.patch : this.post;
  
  if (this.beforeSave) this.beforeSave(toSave,this.rows);

  return method(toSave)
    .then(r => {
      this.setProgress({show:false});
      if (r.id) {
        
        if (this.$socket && this.slot_key) {
          this.$socket.emit('synchro', {
            slot_key: this.slot_key,
            method: this.selectedItem.id? 'patch':'post',
            /* data:{t:'hola'}, */
            user_id:this.user_id,
          });
        }

        if (!this.selectedItem.id || this.new_id === this.selectedItem.id) {
          this.new_id = null;
          if(this.resetRqStatus) this.resetRqStatus();
          if (this.getRows) this.getRows();
          else if(this.items) this.items.push(r);/* v2 */
        }

        const row = this.rows ? this.rows.find(r => r.id === this.selectedItem.id) || {} : {};
        Object.assign(row, this.selectedItem, r);
        Object.assign(this.selectedItem, r); // no reemplaza ni edita las propiedades de tipo array

        this.setSnackbar({message:'Guardado.',class:'success'})
      } else {
        const message = r['r_s_400'] ?  Object.keys(r['r_s_400']).map(a=>r['r_s_400'][a].join(',')).join(''): 'Ocurrió un problema.';
        this.setSnackbar({message,class:'error','multi-line':true,timeout:7000});
      }

      if (this.afterSave) this.afterSave(r,this);
      return r;
    })
    .catch(e => this.getError(e))
}

const askForDelete = function(item) {
  if (item.deleted != true) {
    this.deleteDialog = true;
    this.selectedItem = item;
  }
}

const deleteItem = async function(item) {/* mantener este metodo pero solo con this.delete */
  this.deleteDialog = false;
  item.deleted = true;
  item[this.logic_delete_key] = true;
  this.setProgress({show:true,message: 'Eliminando...'});

  if (!this.scheme) console.warn('no hay scheme definido !!');

  const method = this.logicDelete ? this.patch: this.delete;
  let toSave = this.scheme ? toSaveF(recursiveCopy(item), this.scheme): toSave;

  method(this.logicDelete ? toSave: toSave.id)
    .then(r => {
      this.setProgress({show: false});
      if(this.resetRqStatus) this.resetRqStatus();
      if(this.getRows) this.getRows();
      else if(this.items) this.items.splice(this.items.indexOf(item), 1);/* v2 */ 
      this.setSnackbar({class: 'success', message: 'Registro eliminado!'});
      if (this.afterDeleting) this.afterDeleting(r, item);
    })
    .catch(e => this.getError(e))
} // deleteItem
///////// remplazar mas adelante los 2 de arrbia(solo logico) con los 2 de abajo
const ask_for_toggle = function(item,key) {
  this.toggle_key = key;
  this.toggle_dialog = true;
  this.selectedItem = item;
}

const toggle_item = function(item,key,toggle_met) {
  this.toggle_dialog = false;
  item[key] = !item[key];
  this.setProgress({show:true,message: 'Procesando...'});
  if (!this.scheme) console.warn('no hay scheme definido !!');

  let to_save = this.scheme ? toSaveF(recursiveCopy(item), this.scheme): to_save;
  (this[toggle_met]||this.patch)(to_save)
    .then(r => {
      this.setProgress({show: false});
      if(this.resetRqStatus) this.resetRqStatus();
      if(this.getRows) this.getRows();
      this.setSnackbar({class: 'success', message: 'Registro procesado!'});
      if (this.after_toggle) this.after_toggle(r, item, key);
    })
    .catch(e => this.getError(e))
} // deleteItem

const getRows = async function() {
  const filters = /* {} */parse_filters(this.filters);
  const {page_size} = this.navegation||{};
  if (page_size) filters.page_size = page_size;
  return this.gets(filters)
    .then(r => this.thenGetRows(r));
}

const thenGetRows = function(r) {
  
  if (this.scheme) (((r || {}).results || r) || []).forEach(row => this.setDefault(row));
  
  const rows = this.pagination ? ((r || {}).results || []) : r;
  if (this.beforeSetRows) this.beforeSetRows(rows);
  if (this.st_key) this.$store.dispatch('set', {key: this.st_key, val: rows});
  this.rows = rows;
  
  return r;
}
const setDefault = function(item){
  Object.keys(this.scheme).forEach(key => {
    if(item[key] === undefined) {
      item[key] = this.scheme[key].default !== undefined ? this.scheme[key].default : this.defaultValues[this.scheme[key].type]()
    }
  })
}

const var_type = function(k){
  if (!this.scheme) return false;
  return (this.scheme[k]||{}).type;
}

export {
  var_type,
  beforeSaveIncomplete,
  setDefault,
  thenGetRows,
  defaultItem,
  defaultValues,
  save,
  getRows,
  askForDelete,
  deleteItem,
  ask_for_toggle,
  toggle_item,
}